import { memoize } from "lodash-es";

import { searchRouteParams } from "@/infrastructure/Route";

import { IPasswordSetupMatchProps, IPasswordSetupRouteProps } from "./types";

const transformPropsBody = (props: IPasswordSetupMatchProps) => {
  return {
    token: searchRouteParams(props).get("token"),
  };
};
const transformPropsResolver = (props: IPasswordSetupRouteProps) => props.location.pathname + props.location.search;

export const transformPasswordSetupRouteProps = memoize(transformPropsBody, transformPropsResolver);
